<div class="container-fluid">
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Documentos de Apoio</h4>
        </div>
        <div class="card-body">
          <div class="tree-view">
            <ng-container *ngFor="let arquivo of arquivos">
              <div class="tree-item">
                <div class="tree-content" (click)="toggleExpandir(arquivo)">
                  <i [class]="arquivo.icone" [class.expanded]="arquivo.expandido"></i>
                  <span class="item-name">{{ arquivo.nome }}</span>
                  <span class="item-size" *ngIf="arquivo.tipo === 'arquivo'">
                    {{ getTamanhoFormatado(arquivo.tamanho) }}
                  </span>
                  <span class="item-date" *ngIf="arquivo.tipo === 'arquivo'">
                    {{ getDataFormatada(arquivo.dataModificacao) }}
                  </span>
                </div>
                <div class="tree-children" *ngIf="arquivo.tipo === 'pasta' && arquivo.expandido">
                  <ng-container *ngFor="let filho of arquivo.filhos">
                    <div class="tree-item">
                      <div class="tree-content" (click)="toggleExpandir(filho)">
                        <i [class]="filho.icone" [class.expanded]="filho.expandido"></i>
                        <span class="item-name">{{ filho.nome }}</span>
                        <span class="item-size" *ngIf="filho.tipo === 'arquivo'">
                          {{ getTamanhoFormatado(filho.tamanho) }}
                        </span>
                        <span class="item-date" *ngIf="filho.tipo === 'arquivo'">
                          {{ getDataFormatada(filho.dataModificacao) }}
                        </span>
                      </div>
                      <div class="tree-children" *ngIf="filho.tipo === 'pasta' && filho.expandido">
                        <ng-container *ngFor="let neto of filho.filhos">
                          <div class="tree-item">
                            <div class="tree-content" (click)="toggleExpandir(neto)">
                              <i [class]="neto.icone"></i>
                              <span class="item-name">{{ neto.nome }}</span>
                              <span class="item-size">{{ getTamanhoFormatado(neto.tamanho) }}</span>
                              <span class="item-date">{{ getDataFormatada(neto.dataModificacao) }}</span>
                              <button class="btn btn-sm btn-primary ml-2" 
                                      (click)="downloadArquivo(neto); $event.stopPropagation()">
                                <i class="feather icon-download"></i>
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 